export default __webpack_public_path__ + "static/media/Hindola-Mahal.98a23c9f.jpg";